import actionTypes from '../actionTypes'

export default (payload) => ({
  type: actionTypes.START,
  payload,
})
